import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../styles/Pdash.css";
import axios from "axios";
import Swal from "sweetalert2";

const PetaniDashboard = () => {
  const [userInfo, setUserInfo] = useState({
    role: "Guest",
    name: "Guest",
    full_name: "Guest",
  });
  const [totalTransaksi, setTotalTransaksi] = useState(0);
  const [pendingApproval, setPendingApproval] = useState(0);
  const [approvedCount, setApprovedCount] = useState(0);
  const [lahan, setLahan] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [tanggal, setTanggal] = useState("");

  const handleProfileClick = () => {
    navigate("/profile");
  };

  useEffect(() => {
    setTanggal(
      new Date().toLocaleDateString("id-ID", {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric",
      })
    );

    axios
      .get("https://c-greenproject.org:7500/get_user_role", {
        withCredentials: true,
      })
      .then((response) => {
        const data = response.data;
        if (!data.error) {
          setUserInfo({
            role: data.role,
            name: data.name,
            full_name: data.full_name,
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching user info:", error);
      });

    axios
      .get("https://c-greenproject.org:7500/riwayat", { withCredentials: true })
      .then((response) => {
        const pengirimanHistory = response.data || [];
        let transaksiCount = 0;

        pengirimanHistory.forEach((entry) => {
          if (entry.tracking_id) {
            transaksiCount++;
          }
        });

        setTotalTransaksi(transaksiCount);
      })
      .catch((error) => {
        console.error("Error fetching pengiriman history:", error);
      });

    axios
      .get("https://c-greenproject.org:7500/view_panen", {
        withCredentials: true,
      })
      .then((response) => {
        const panenList = response.data.panens || [];
        const pendingPanenCount = panenList.filter(
          (panen) => panen.status !== "approved" && panen.status !== "rejected"
        ).length;
        const approvedPanenCount = panenList.filter(
          (panen) => panen.status === "approved"
        ).length;

        axios
          .get("https://c-greenproject.org:7500/view_rencana_tanam", {
            withCredentials: true,
          })
          .then((responseTanam) => {
            const tanamList = responseTanam.data.tanams || [];
            const pendingTanamCount = tanamList.filter(
              (tanam) =>
                tanam.status_validasi !== "approved" &&
                tanam.status_validasi !== "rejected"
            ).length;
            const approvedTanamCount = tanamList.filter(
              (tanam) => tanam.status_validasi === "approved"
            ).length;

            setPendingApproval(pendingPanenCount + pendingTanamCount);
            setApprovedCount(approvedPanenCount + approvedTanamCount);
          })
          .catch((errorTanam) => {
            console.error("Error fetching rencana tanam:", errorTanam);
          });
      })
      .catch((errorPanen) => {
        console.error("Error fetching rencana panen:", errorPanen);
      });

    axios
      .get("https://c-greenproject.org:7500/lahan", { withCredentials: true })
      .then((response) => {
        const lahanData = response.data.lahan || [];
        setLahan(lahanData);
      })
      .catch((error) => {
        console.error("Error fetching lahan data:", error);
      });
  }, []);

  const handleLogout = async () => {
    try {
      await axios.post(
        "https://c-greenproject.org:7500/logout",
        {},
        { withCredentials: true }
      );
    } catch (error) {
      console.warn("Logout error fallback:", error);
    } finally {
      localStorage.clear();
      sessionStorage.clear();
      navigate("/");
    }
  };

  const metricCards = [
    {
      id: 1,
      variantBg: "bg-danger-subtle",
      variantText: "text-danger",
      title: totalTransaksi,
      text: "Penjualan Saat Ini",
      icon: "/static/sell_8087698.png",
      filterColor:
        "invert(27%) sepia(51%) saturate(2878%) hue-rotate(346deg) brightness(104%) contrast(97%)",
    },
    {
      id: 2,
      variantBg: "bg-warning-subtle",
      variantText: "text-warning-emphasis",
      title: pendingApproval,
      text: "Menunggu Approval",
      icon: "/static/schedule_11145854.png",
      filterColor:
        "invert(65%) sepia(45%) saturate(544%) hue-rotate(357deg) brightness(96%) contrast(91%)",
    },
    {
      id: 3,
      variantBg: "bg-primary-subtle",
      variantText: "text-primary",
      title: approvedCount,
      text: "Approved",
      icon: "/static/schedule_11145854.png",
      filterColor:
        "invert(25%) sepia(96%) saturate(1610%) hue-rotate(200deg) brightness(98%) contrast(98%)",
    },
    {
      id: 4,
      variantBg: "bg-success-subtle",
      variantText: "text-success",
      title: "Harga",
      text: "Harga Sawit Hari Ini",
      icon: "/static/sell_8087698.png",
      onClick: () => navigate("/sawitp"),
      filterColor:
        "invert(35%) sepia(91%) saturate(403%) hue-rotate(101deg) brightness(93%) contrast(91%)",
    },
  ];

  return (
    <div className="d-flex flex-column min-vh-100" style={{ backgroundColor: "#f8fafc" }}>
      <div className="d-flex justify-content-between align-items-center px-4 py-2.5 bg-white border-bottom shadow-sm">
        <img src="/static/logo_potrait.png" alt="Logo Telsa Super Apps" style={{ height: "36px" }} />
        <div className="d-flex align-items-center gap-3">
          <span
            id="user-role"
            className="fw-semibold text-secondary small"
            onClick={handleProfileClick}
            style={{ cursor: "pointer" }}
            title="Klik untuk melihat profil"
          >
            {userInfo.full_name} |
          </span>
          <button
            className="btn btn-outline-danger btn-sm rounded-pill px-3 py-1"
            onClick={handleLogout}
          >
            Keluar
          </button>
        </div>
      </div>

      <div className="d-flex flex-grow-1">
        <div className="p-3 bg-white border-end shadow-sm" style={{ width: "240px", flexShrink: 0 }}>
          <p className="text-muted small mb-1">Portal Sistem Traceability</p>
          <h6 className="fw-bold text-success mb-3">Telsa Super Apps</h6>
          <p className="bg-light p-2 rounded-3 text-muted small fw-medium d-flex align-items-center gap-2 mb-4" style={{ fontSize: "12px" }}>
            <img src="/static/schedule_11145854.png" alt="Date" style={{ width: "14px" }} />
            {tanggal}
          </p>

          <div className="d-flex flex-column gap-1">
            <div
              onClick={() => navigate("/petani")}
              className={`p-2 rounded-3 d-flex align-items-center gap-2 ${
                location.pathname === "/petani" ? "bg-success text-white fw-bold" : "text-dark"
              }`}
              style={{ cursor: "pointer", fontSize: "14px" }}
            >
              <img
                src="/static/eco-home_7633847.png"
                alt="Home"
                style={{
                  width: "18px",
                  filter: location.pathname === "/petani" ? "brightness(0) invert(1)" : "none",
                }}
              />
              Beranda
            </div>
            <div
              onClick={() => navigate("/petanirt")}
              className={`p-2 rounded-3 d-flex align-items-center gap-2 ${
                location.pathname === "/petanirt" ? "bg-success text-white fw-bold" : "text-dark"
              }`}
              style={{ cursor: "pointer", fontSize: "14px" }}
            >
              <img
                src="/static/Tanam.png"
                alt="Planting"
                style={{
                  width: "18px",
                  filter: location.pathname === "/petanirt" ? "brightness(0) invert(1)" : "none",
                }}
              />
              Rencana Tanam
            </div>
            <div
              onClick={() => navigate("/petanirp")}
              className={`p-2 rounded-3 d-flex align-items-center gap-2 ${
                location.pathname === "/petanirp" ? "bg-success text-white fw-bold" : "text-dark"
              }`}
              style={{ cursor: "pointer", fontSize: "14px" }}
            >
              <img
                src="/static/panen.png"
                alt="Harvest"
                style={{
                  width: "18px",
                  filter: location.pathname === "/petanirp" ? "brightness(0) invert(1)" : "none",
                }}
              />
              Rencana Panen
            </div>
            <div
              onClick={() => navigate("/petanifp")}
              className={`p-2 rounded-3 d-flex align-items-center gap-2 ${
                location.pathname === "/petanifp" ? "bg-success text-white fw-bold" : "text-dark"
              }`}
              style={{ cursor: "pointer", fontSize: "14px" }}
            >
              <img
                src="/static/FinalPanen.png"
                alt="Final Panen"
                style={{
                  width: "18px",
                  filter: location.pathname === "/petanifp" ? "brightness(0) invert(1)" : "none",
                }}
              />
              Final Panen
            </div>
            <div
              onClick={() => navigate("/petanip")}
              className={`p-2 rounded-3 d-flex align-items-center gap-2 ${
                location.pathname === "/petanip" ? "bg-success text-white fw-bold" : "text-dark"
              }`}
              style={{ cursor: "pointer", fontSize: "14px" }}
            >
              <img
                src="/static/sell_8087698.png"
                alt="Sales"
                style={{
                  width: "18px",
                  filter: location.pathname === "/petanip" ? "brightness(0) invert(1)" : "none",
                }}
              />
              Penjualan
            </div>
          </div>
        </div>

        <div
          className="flex-grow-1 p-4"
          style={{
            width: "calc(100% - 240px)",
            minWidth: 0,
            overflowX: "hidden",
          }}
        >
          <div className="mb-4">
            <h3 className="fw-bold text-dark mb-1">Beranda Dashboard</h3>
            <p className="text-secondary small mb-0">
              Selamat datang kembali, <strong>{userInfo.full_name}</strong>!
            </p>
          </div>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: "16px",
              marginBottom: "24px",
              width: "100%",
            }}
          >
            {metricCards.map((card) => (
              <div
                key={card.id}
                className="bg-white rounded-4 shadow-sm border p-3.5 d-flex flex-column justify-content-between"
                onClick={card.onClick}
                style={{
                  minHeight: "135px",
                  cursor: card.onClick ? "pointer" : "default",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease",
                }}
              >
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <h2 className="fw-bold text-dark mb-1 font-monospace">{card.title}</h2>
                    <p className="text-secondary fw-medium small mb-0" style={{ fontSize: "13px" }}>
                      {card.text}
                    </p>
                  </div>
                  <div
                    className={`${card.variantBg} ${card.variantText} p-3 rounded-4 d-flex align-items-center justify-content-center flex-shrink-0`}
                    style={{ width: "50px", height: "50px" }}
                  >
                    <img src={card.icon} alt={card.text} style={{ width: "22px", filter: card.filterColor }} />
                  </div>
                </div>
                {card.onClick && (
                  <div className="mt-2 pt-2 border-top small text-success fw-semibold d-flex align-items-center justify-content-between" style={{ fontSize: "12px" }}>
                    <span>Cek informasi pasar</span>
                    <span>→</span>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="bg-white rounded-4 shadow-sm border p-4" style={{ width: "100%", minWidth: 0 }}>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <div>
                <h5 className="fw-bold text-success mb-0">Daftar Lahan Terdaftar</h5>
                <span className="text-muted small">Total {lahan.length} plot lahan aktif terdaftar</span>
              </div>
            </div>

            {lahan && lahan.length > 0 ? (
              <div className="table-responsive w-100">
                <table className="table table-hover align-middle mb-0 w-100" style={{ tableLayout: "auto" }}>
                  <thead className="table-light">
                    <tr className="text-secondary small fw-semibold">
                      <th className="text-center py-3" style={{ width: "80px" }}>
                        ID
                      </th>
                      <th className="py-3" style={{ width: "220px" }}>
                        NAMA LAHAN
                      </th>
                      <th className="py-3">
                        ALAMAT LAHAN
                      </th>
                      <th className="text-center py-3" style={{ width: "200px" }}>
                        STATUS SERTIFIKASI
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {lahan.map((lahanItem, idx) => (
                      <tr key={`lahan-${lahanItem.id_lahan || lahanItem.id || idx}`}>
                        <td className="text-center font-monospace fw-bold text-secondary py-3">
                          #{lahanItem.id_lahan || lahanItem.id}
                        </td>
                        <td className="py-3">
                          <span className="fw-bold text-dark d-block">
                            {lahanItem.nama_lahan || "-"}
                          </span>
                        </td>
                        <td className="py-3 text-secondary" style={{ wordBreak: "break-word", maxWidth: "400px" }}>
                          <span className="small leading-relaxed">
                            {lahanItem.alamat_lahan || "-"}
                          </span>
                        </td>
                        <td className="text-center py-3">
                          <span className="badge bg-success-subtle text-success px-3 py-2 rounded-pill border border-success-subtle fw-semibold">
                            {lahanItem.status_sertifikasi_lahan || "Terverifikasi"}
                          </span>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5 text-muted bg-light rounded-3 mt-2">
                <span className="fs-1 d-block mb-2">🌱</span>
                <h6 className="fw-semibold">Belum Ada Lahan</h6>
                <p className="mb-0 small">Tidak ada data lahan yang terdaftar saat ini.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetaniDashboard;